"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pagination = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Pagination = require("./Pagination.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 分頁
 */

const Pagination = _ref => {
  let {
    variant = "default",
    textcolor = "#fff",
    current = 1,
    defaultCurrent = 1,
    pageSizeOptions = [100, 25, 20, 15, 10],
    total,
    onChange,
    defaultPageSize = 10
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Pagination.UiPagination, {
    variant: variant,
    textcolor: textcolor
  }, total > 0 && total > defaultPageSize && /*#__PURE__*/_react.default.createElement(_antd.Pagination, {
    current: current,
    defaultCurrent: defaultCurrent,
    pageSizeOptions: pageSizeOptions,
    total: total,
    onChange: onChange,
    defaultPageSize: defaultPageSize
  }));
};
exports.Pagination = Pagination;
var _default = exports.default = Pagination;
Pagination.propTypes = {
  variant: _propTypes.default.string,
  textcolor: _propTypes.default.string,
  current: _propTypes.default.number,
  defaultCurrent: _propTypes.default.number,
  pageSizeOptions: _propTypes.default.array,
  total: _propTypes.default.number,
  onChange: _propTypes.default.func,
  defaultPageSize: _propTypes.default.number
};